import React from "react";
import { Link } from "react-router-dom";
import { GiMeditation, GiDramaMasks } from "react-icons/gi";
import {Activity, Car, ImageMinusIcon} from "lucide-react";
import { Leaf, CupSoda, Banknote } from "lucide-react";

const BottomActionBar = ({ visible }) => {
    if (!visible) return null;

    return (
        <div className="fixed top-16 left-0 w-full bg-white border-b border-gray-300 shadow-inner sm:hidden z-40 overflow-x-auto">
            <div className="flex justify-start items-center py-2 px-1 text-center text-xs text-gray-800 space-x-4 whitespace-nowrap overflow-x-auto">

                <Link to="/services" className="flex flex-col items-center min-w-[64px] hover:text-blue-600">
                    <Activity className="w-5 h-5 mb-1" />
                    <span className="text-[10px]">Our Activity</span>
                </Link>

                <Link to="/wellness" className="flex flex-col items-center min-w-[64px] hover:text-blue-600">
                    <GiMeditation className="w-5 h-5 mb-1" />
                    <span className="text-[10px]">Wellness</span>
                </Link>
                <Link to="/travel" className="flex flex-col items-center min-w-[64px] hover:text-blue-600">
                    <Car className="w-5 h-5 mb-1 " />
                    <span className="text-[10px]">Travel Pakages</span>
                </Link>

                <Link to="/tea" className="flex flex-col items-center min-w-[64px] hover:text-blue-600">
                    <CupSoda className="w-5 h-5 mb-1" />
                    <span className="text-[10px]">Herbal Tea</span>
                </Link>

                <Link to="/ayurveda" className="flex flex-col items-center min-w-[64px] hover:text-blue-600">
                    <Leaf className="w-5 h-5 mb-1" />
                    <span className="text-[10px] ">Ayurveda Products</span>
                </Link>
                <Link to="/bank" className="flex flex-col items-center min-w-[64px] hover:text-blue-600">
                    <Banknote className="w-5 h-5 mb-1" />
                    <span className="text-[10px]">Bank Info</span>
                </Link>
                <Link to="/gallery" className="flex flex-col items-center min-w-[64px] hover:text-blue-600">
                    <ImageMinusIcon className="w-5 h-5 mb-1"/>
                    <span className="text-[10px]">Gallery</span>
                </Link>
                <Link to="/masks" className="flex flex-col items-center min-w-[64px] hover:text-blue-600">
                    <GiDramaMasks className="w-5 h-5 mb-1" />
                    <span className="text-[10px]">Masks</span>
                </Link>
            </div>
        </div>
    );
};

export default BottomActionBar;
